import React from "react";
import { Controller, Control, FieldValues, Path, PathValue } from "react-hook-form";
import ReactSlider from "react-slider";
import styles from "./RangeSlider.module.scss";

interface ControlledRangeSliderProps<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
	min?: number;
	max?: number;
	step?: number;
	disabled?: boolean;
	minDistance?: number;
}

export const RangeSlider = <T extends FieldValues>({
	control,
	name,
	min = 0,
	max = 100,
	step = 1,
	disabled = false,
	minDistance = 1,
}: ControlledRangeSliderProps<T>) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={[0, 0] as PathValue<T, Path<T>>}
			render={({ field }) => (
				<div className={styles.rangeContainer} style={disabled ? { pointerEvents: "none", opacity: 0.5 } : {}}>
					<ReactSlider
						value={Array.isArray(field.value) && field.value.length === 2 ? (field.value as Array<number>) : [0, 0]}
						onChange={field.onChange}
						min={min}
						max={max}
						step={step}
						className={styles.rangeSlider}
						thumbClassName={styles.rangeThumb}
						trackClassName={styles.rangeTrack}
						renderThumb={(props, state) => (
							<div {...props}>
								<div className={styles.tooltip}>{state.valueNow}</div>
							</div>
						)}
						disabled={disabled}
						minDistance={minDistance}
					/>
					<div className={styles.rangeLabels}>
						<span>{min}</span>
						<span>{max}</span>
					</div>
				</div>
			)}
		/>
	);
};
